
import { defineComponent, reactive, toRefs } from 'vue'
import { useRoute } from 'vue-router'

export default defineComponent({
    setup(prop) {
        const route = useRoute()
        let str = `https://qiniu.xfarmer.com/202112/2231153737211201000787952.png`
        const states = reactive({ url: route.query.url?route.query.url:str,type:route.query.url?false:true})
        return {
            ...toRefs(states)
        }
    },
})
